var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelicopter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 2 3 L 2 5 L 9 5 L 9 3 L 2 3 z M 11 3 L 11 6.2050781 C 8.584 6.6840781 7.012375 7.956 6.359375 9 L 4 9 L 4 7 L 2 7 L 2 13 L 4 13 L 4 11 L 6 11 L 6 13.300781 C 6 15.370781 7.8795313 17 10.269531 17 L 13.810547 17 C 16.170547 17 21.570703 17 21.970703 13 L 17 13 C 14.79 13 13 11.21 13 9 L 13 3 L 11 3 z M 15 3 L 15 5 L 22 5 L 22 3 L 15 3 z M 15 6.1699219 L 15 9 C 15 10.1 15.9 11 17 11 L 21.740234 11 C 20.940234 8.64 18.28 6.7299219 15 6.1699219 z M 21 18 C 21 18.552 20.552 19 20 19 L 6 19 L 6 21 L 20 21 C 21.654 21 23 19.654 23 18 L 21 18 z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelicopter);
export default __webpack_public_path__ + "static/media/helicopter.ae278edd5c59e44736dd4e03cedb7cad.svg";
export { ForwardRef as ReactComponent };